import { GovernmentIdFieldsPerCountry } from 'constants/governmentIdFields';
import {} from './GovernmentIdFieldSet.types';
export const getGovernmentIdOptions = ({ companyType, countryCode }) => GovernmentIdFieldsPerCountry[countryCode]?.[companyType] || [];
